import { render } from "./OrderDetailsModal.vue?vue&type=template&id=4c71e924&scoped=true"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js"

import "./OrderDetailsModal.vue?vue&type=style&index=0&id=4c71e924&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c71e924"]])

export default __exports__